export const srlValueFields = [{
        name: "code",
        title: "Codice"
    }, {
        name: "displayOrder",
        title: "Ordine"
    }, {
        name: "description",
        title: "Descrizione"
    }, {
        name: "initial",
        title: "Stato Iniziale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.initial === 1 ? "check" : ""}</i>`
    }, {
        name: "final",
        title: "Stato Finale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.final === 1 ? "check" : ""}</i>`
    }, {
        name: "success",
        title: "Esito Successo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.success === 1 ? "check" : ""}</i>`
    }, {
        name: "failure",
        title: "Esito Fallimento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.failure === 1 ? "check" : ""}</i>`
    }];
